var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"card-kingdom"}},[_c('div',{staticClass:"full-page"},[_c('div',{staticClass:"wallpaper"},[_c('div',{staticClass:"box"},[_vm._v(" ข้าพระพุทธเจ้า "),_c('br'),_c('ul',{staticClass:"swap"},_vm._l((_vm.show_names),function(item,index){return _c('li',{key:index},[_vm._v("     "+_vm._s(item.sign_name)+" ")])}),0)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }